import GroupedProductItem from "./GroupedProductItem";
// Grouped Listing
const GroupedCart = ({ groupedCart, ...otherProps }) => (
  <>
    {Object.entries(groupedCart).map(([provider, items]) => (
      <div key={provider} style={{ marginBottom: "20px" }}>
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "semibold",
            marginBottom: "10px",
          }}
        >
          {provider}
        </h3>
        {/* <div style={{ overflowX: 'auto' }}> */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
          }}
        >
          {items.map((item) => (
            <GroupedProductItem
              key={item.id}
              product={item}
              {...otherProps}
              isGroupedListing={true}
            />
          ))}
        </div>
      </div>
    ))}
  </>
);

export default GroupedCart;
